module.exports = __webpack_public_path__ + "media/elevadizo/buqueCargadorDerecha-9cfb5ff3.png";